import React, {Component} from 'react';
import axios from 'axios';
import $ from 'jquery';
import Header from "./Header";
import SideBar from "./SideBar";
import Chart from 'chart.js/auto';
import Data from "./Data";
import {CircularProgress} from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroller";
import StudentsList from "./StudentsList";
import MastersList from "./MastersList";
import ModalEditMaster from "./ModalEditMaster";
import ModalAddMaster from "./ModalAddMaster";
import { useState } from 'react';

class MastersPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            articles : [],
            nextPage: 0,
            hasMore: true,
            length:0,
            instrumentList:null,
            toast:<div>

            </div>
        };

        this.myRef = null;
        this.setMyRefRef = element => {
            this.myRef = element;
        };

        this.loader = null;
        this.setMyLoader = element => {
            this.loader = element;
        };
    }

    componentDidMount() {
        $('#progressTop').addClass('invisible');
        $('#no_item').addClass('invisible');
        
    }

    handleLoadMore(){

        let token = localStorage.getItem('token');
        let data = new FormData();
        data.append('token', '');
        data.append('how', '10');
        data.append('count', this.state.nextPage);
        this.setState({
            hasMore: false
        })
        axios.post(Data.server+`getMasters.php`,data)
            .then(response => {

                if (response.data.hasOwnProperty('data') &&
                    response.data.hasOwnProperty('length') &&
                    response.data.hasOwnProperty('row')) {

                    const {row, length, data} = response.data;
                    this.setState(prevState => ({
                        articles: [...prevState.articles, ...data],
                        hasMore: length - this.state.articles.length > 0,
                        length: length,
                        nextPage: row
                    }));

                }
                if (response.data.hasOwnProperty('invalid_token')) {
                    this.props.logout();
                }
                if (response.data.hasOwnProperty('no_item')) {
                    $('#no_item').removeClass('invisible');

                }
            })
            .catch(error => {
                console.log(error)
            });
    }

    handlelength(){
        this.setState({
            length : this.state.length-1
        })
    }

    handleToast(text,delay,background,callback){
        this.setState({
            toast:
                <div className="position-fixed bottom-0 left-0" style={{zIndex: 5, left: 8, bottom: 8}}>
                    <div id="liveToast" className={background+" radius toast fade hide p-3"}
                         role="alert" aria-live="assertive" aria-atomic="true"
                         data-delay={delay}>
                        <div className="toast-body text-white">
                            {text}
                            <button type="button" className="text-left mb-1 close text-white" data-dismiss="toast"
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                        </div>
                    </div>
                </div>

        },callback);
    }


    render() {

        
        $('#progressTop').addClass('invisible');
        const {articles,length,toast} = this.state;

        if (articles.length === parseInt(length) && articles.length !== 0){
            $('#loading').addClass("novisible")
        } else {
            $('#loading').removeClass("novisible")
        }
        return (
                <div className="container-fluid">
                {toast}
                        <SideBar li="masterspanel" />
                        <div className="col-12 bg-light p-4 homee" id="masters">
                            <div
                                className="d-flex justify-content-between align-items-center flex-md-nowrap border-bottom pb-2 my-3">
                                <h1 className="h3">{'تعداد استادان : '+length}</h1>

                                <button className="btn btn-success btn-lg" data-toggle="modal" data-target={"#addmastermodal"}>افزودن استاد</button>
                                <ModalAddMaster
                                    toast={this.handleToast.bind(this)}
                                    id="addmastermodal" />

                            </div>

                            <div className="table-responsive radius">
                                <table className="table table-condensed table-bordered table-striped table-hover text-center">
                                    <thead>
                                    <tr className="table-secondary">
                                        <th>عکس نمایه</th>
                                        <th>نام و نام خانوادگی</th>
                                        <th>نام کاربری</th>
                                        <th>شماره موبایل</th>
                                        <th>بیوگرافی</th>
                                        <th>مدرس</th>
                                        <th>روزهای کاری</th>
                                        <th>ویرایش / حذف</th>
                                    </tr>
                                    </thead>
                                    <InfiniteScroll
                                        element="tbody"
                                        className=""
                                        ref={this.setMyLoader}
                                        hasMore={this.state.hasMore}
                                        loadMore={this.handleLoadMore.bind(this)}
                                        getScrollParent={() => this.myRef}>

                                        {this.state.articles.map((products, index) => <MastersList toast={this.handleToast.bind(this)} length={this.handlelength.bind(this)} products={products} index={index}/>)}

                                    </InfiniteScroll>

                                </table>
                                <div id="loading" className="mr-auto ml-auto mt-2 text-muted text-center">
                                    <h3 className="h3">در حال بارگذاری ...</h3>
                                    <CircularProgress color="secondary"/>
                                </div>
                            </div>

                        </div>
                    </div>
        );

    }
}

export default MastersPanel;
